





















import CoImage from '@/components/Atoms/co-image/CoImage.vue';
import CoCoappBadge from '@/components/Organisms/co-coapp-badge/CoCoappBadge.vue';

export default {
    name: 'MainEmbed',
    components: {
        CoImage,
        CoCoappBadge,
    },
    data() {
        return {
            showSignup: false,
            signUpStrategy: {},
            inviteOnly: false,
        };
    },
    computed: {
        cobranded() {
            if (!this.$store) return false;
            if (!this.$store.state.space) return false;

            if (this.$store.state.space.PlanSlug === 'free') {
                return true;
            }
            return false;
        },
        hideSignup() {
            if (this.inviteOnly) {
                return true;
            }

            if (!this.showSignup) {
                return true;
            }

            return false;
        },
        // get space name from store
        // Don't user lodash get here, it doesn't work with reactive data
        spaceName() {
            if (!this.$store) return '';
            return this.$store.state.space.Name;
        },
        // Don't user lodash get here, it doesn't work with reactive data
        logoURL() {
            if (!this.$store) return '';
            return this.$store.state.space.LogoURL;
        },
        // Don't user lodash get here, it doesn't work with reactive data
        path() {
            return this.$route.path;
        },
    },
    methods: {},
};
